import { Dialog, Transition } from "@headlessui/react";
import { Fragment, useState, useEffect } from "react";

export default function DeleteRelatedPersonDialog({
    open,
    onClose,
    onConfirm,
    personName,
}: {
    open: boolean;
    onClose: () => void;
    onConfirm: () => void;
    personName: string;
}) {
    const [confirmText, setConfirmText] = useState("");

    const canDelete = confirmText.trim().toLowerCase() === "delete account";

    // reset input when dialog opens
    useEffect(() => {
        if (open) setConfirmText("");
    }, [open]);

    return (
        <Transition.Root show={open} as={Fragment}>
            <Dialog as="div" className="relative z-50" onClose={onClose}>
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-200"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-150"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-black/40 backdrop-blur-sm" />
                </Transition.Child>

                <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-200"
                        enterFrom="opacity-0 scale-95"
                        enterTo="opacity-100 scale-100"
                        leave="ease-in duration-150"
                        leaveFrom="opacity-100 scale-100"
                        leaveTo="opacity-0 scale-95"
                    >
                        <Dialog.Panel className="w-full max-w-sm rounded-2xl bg-dark-background-secondary p-6 text-white shadow-xl">
                            <Dialog.Title className="text-lg font-semibold">
                                Delete related person account?
                            </Dialog.Title>
                            <Dialog.Description className="text-sm text-dark-text mt-1">
                                Once you delete{" "}
                                <span className="text-white font-medium">{personName}</span>’s
                                account, we will be removing their data. You will not be able to run
                                any future reports with them.
                            </Dialog.Description>

                            <div className="mt-4">
                                <label className="block text-sm text-dark-text mb-1">
                                    Type the words{" "}
                                    <span className="font-medium text-white">"delete account"</span>{" "}
                                    below:
                                </label>
                                <input
                                    type="text"
                                    value={confirmText}
                                    onChange={(e) => setConfirmText(e.target.value)}
                                    className="w-full rounded-lg border border-dark-border bg-dark-background-secondary-medium px-3 py-2 text-sm text-white placeholder:text-dark-text focus:outline-none focus:ring-1 focus:ring-brand-500"
                                    placeholder="delete account"
                                />
                            </div>

                            <div className="mt-6 flex justify-end gap-3">
                                <button
                                    type="button"
                                    className="rounded-lg bg-dark-background-secondary-medium px-4 py-2 text-sm text-dark-text hover:bg-dark-background-secondary border border-dark-border"
                                    onClick={onClose}
                                >
                                    No, go back
                                </button>
                                <button
                                    type="button"
                                    disabled={!canDelete}
                                    className={`rounded-lg px-4 py-2 text-sm font-medium text-white transition
    ${canDelete
                                            ? "bg-brand-600 hover:bg-brand-500 cursor-pointer"
                                            : "bg-gray-600 opacity-60 cursor-not-allowed"
                                        }`}
                                    onClick={onConfirm}
                                >
                                    Yes, delete
                                </button>

                            </div>
                        </Dialog.Panel>
                    </Transition.Child>
                </div>
            </Dialog>
        </Transition.Root>
    );
}
